import { Component } from '@angular/core';
import { Subscription } from '../data/subscription';
import { FordService } from '../services/ford.service';
import { forkJoin } from 'rxjs';
import { Dealer, DealerCurrent, DealerStatus } from '../data/dealer';
import { PriceTier } from '../data/price-tier';
import { PriceTierService } from '../services/price-tier.service';
import { Price } from '../data/price';
import { Router, ActivatedRoute } from '@angular/router';
import { FuncsService } from '../services/funcs.service';
import { DealerService } from '../services/dealer.service';

@Component({
  selector: 'app-enroll',
  templateUrl: './enroll.component.html',
  styleUrls: ['./enroll.component.css'],
  standalone: false
})
export class EnrollComponent {
  constructor(
    private dealerService: DealerService,
    private fordService: FordService,
    private _router: Router,
    private priceTierService: PriceTierService,
    private funcs: FuncsService,
    private route: ActivatedRoute
  ) { }

  sub: Subscription = {
    createdAt: "",
    startDate: "",
    siteCode: "",
    maxAllowedUniqueDealerTechnicianLogins: 0,
    concurrentSessions: 0,
    expiresAt: "",
    status: 0
  };

  prices: Price = {
    per_tech: 0,
    monthly: 0,
    can_price: 0,
    can_monthly: 0
  };

  fleetPrices: Price = {
    per_tech: 0,
    monthly: 0,
    can_price: 0,
    can_monthly: 0
  };

  public price = 0;
  public monthly = 0;
  public fleetPrice = 0;
  public fleetMonthly = 0;
  public expires = "";
  dealer: Dealer = DealerCurrent;
  dealerStatus: DealerStatus = <DealerStatus>{};
  priceTiers: PriceTier[] = [];
  canadaPriceTiers: PriceTier[] = [];
  fleetPriceTiers: PriceTier[] = [];
  subscribed: boolean = false;
  public enrolled = "";
  tech_count: number = 0;
  ref: any;
  fleet: boolean = false;
  countUpdated: boolean = false;

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(queryParams => {
      this.ref = queryParams.get('ref');
      if (this.ref == "fleet") {
        this.fleet = true;
      }
    });
    // this.dealer.tech_count = 0;
    this.funcs.currentDealer(this.dealer);
    this.getSubscription();
  }

  getUsername(pa_code: string): string {
    var country = this.funcs.getThreeLetterCountry(pa_code);
    if (country == "USA" || country == "CAN") {
      pa_code = pa_code.slice(3);
    }
    var username = "";
    if (this.fleet) {
      username = `FIN${pa_code}`;
    } else {
      username = `FCT${pa_code}`
    }

    return username;
  }

  getSubscription(): void {
  
    forkJoin({
      priceTiers: this.priceTierService.getPriceTiers(),
      canadaPriceTiers: this.priceTierService.getCanadaPriceTiers(),
      fleetPriceTiers: this.priceTierService.getFleetPriceTiers()
    }).subscribe(({ priceTiers, canadaPriceTiers, fleetPriceTiers }) => {
      this.priceTiers = priceTiers;
      this.canadaPriceTiers = canadaPriceTiers;
      this.fleetPriceTiers = fleetPriceTiers;

      this.priceTiers = this.priceTiers.sort((a, b) => {
        return a.qty - b.qty;
      });
      this.priceTiers.forEach(pt => {
        if (pt.qty <= this.dealer.tech_count) {
          this.prices.per_tech = pt.price;
          // this.prices.can_price = pt.price_canadian_dollar;
        }
      });

      this.canadaPriceTiers = this.canadaPriceTiers.sort((a, b) => {
        return a.qty - b.qty;
      });
      this.canadaPriceTiers.forEach(cpt => {
        if (cpt.qty <= this.dealer.tech_count) {
          this.prices.can_price = cpt.price_canadian_dollar;
        }
      });

      this.fleetPriceTiers = this.fleetPriceTiers.sort((a, b) => {
        return a.qty - b.qty;
      });

      this.fleetPriceTiers.forEach(fpt => {
        if (fpt.qty <= this.dealer.tech_count) {
          this.fleetPrices.per_tech = fpt.price;
          this.fleetPrices.can_price = fpt.price_canadian_dollar;
        }
      });
    });
      
    var dealerCountry = "";
    const dealerStatusData = this.dealerService.getSingleDealerStatus(this.getUsername(this.dealer.pa_code));
    const subscriptionData = this.fordService.getSubscription(this.dealer.pa_code);

    forkJoin([dealerStatusData, subscriptionData]).subscribe(responses => {
      this.dealerStatus = responses[0];
      if (responses[1].siteCode) {
        this.sub = responses[1];
        if (!this.sub.maxAllowedUniqueDealerTechnicianLogins) {
          this.sub.maxAllowedUniqueDealerTechnicianLogins = 0;
        }
        // this.subscribed = true;
        this.subscribed = this.funcs.isSubscribed(responses[1]);
      } else {
        this.subscribed = false;
      }

      if (!this.sub.startDate) {
        this.sub.startDate = (new Date(0)).toISOString();
      }
      if (!this.sub.expiresAt) {
        this.sub.expiresAt = (new Date(0)).toISOString();
      }
      if (!this.sub.maxAllowedUniqueDealerTechnicianLogins) {
        // sub.maxAllowedUniqueDealerTechnicianLogins = this.dealer.tech_count + 5;
        this.sub.siteCode = this.dealer.pa_code;
        this.sub.maxAllowedUniqueDealerTechnicianLogins = this.dealer.tech_count;
      }
      if (!this.sub.concurrentSessions) {
        this.sub.concurrentSessions = 5;
      }

      // this.sub.maxAllowedUniqueDealerTechnicianLogins = sub.maxAllowedUniqueDealerTechnicianLogins;

      this.subscribed = this.funcs.isSubscribed(this.sub);

      dealerCountry = this.funcs.getThreeLetterCountry(this.sub.siteCode);

      if (!this.subscribed && dealerCountry === 'USA' || dealerCountry === 'CAN') {
        // get our tech count
        if (this.fleet) {
          this.dealerService.getFleetDealer(this.funcs.stripCountry(this.sub.siteCode)).subscribe(d => {
            this.tech_count = d.tech_count;
          });
        } else {
          this.dealerService.getDealer(this.funcs.stripCountry(this.sub.siteCode)).subscribe(d => {
            this.tech_count = d.tech_count;
          });
        }
      } else {
        this.tech_count = this.sub.maxAllowedUniqueDealerTechnicianLogins;
      }
      this.enrolled = new Date(this.sub.createdAt).toDateString();

      if (dealerCountry === "CAN") {
        this.dealerStatus.tech_count = this.dealerStatus.tech_count == null ? this.sub.maxAllowedUniqueDealerTechnicianLogins : this.dealerStatus.tech_count;

        this.prices.can_monthly = (this.prices.can_price * this.dealerStatus.tech_count) / 12;
        this.fleetPrices.can_monthly = (this.fleetPrices.can_price * this.dealerStatus.tech_count) / 12;

        if (this.fleet) {
          this.fleetPrice = this.fleetPrices.can_price;
          this.fleetMonthly = this.fleetPrices.can_monthly;
        } else {
          this.price = this.prices.can_price;
          this.monthly = this.prices.can_monthly;
        }
      } else if (dealerCountry === "USA") {
        this.dealerStatus.tech_count = this.dealerStatus.tech_count == null ? this.sub.maxAllowedUniqueDealerTechnicianLogins : this.dealerStatus.tech_count;

        this.prices.monthly = (this.prices.per_tech * this.dealerStatus.tech_count) / 12;
        this.fleetPrices.monthly = (this.fleetPrices.per_tech * this.dealerStatus.tech_count) / 12;

        if (this.fleet) {
          this.fleetPrice = this.fleetPrices.per_tech;
          this.fleetMonthly = this.fleetPrices.monthly;
        } else {
          this.price = this.prices.per_tech;
          this.monthly = this.prices.monthly;
        }
      }
    });

    if (this.fleet && ((this.dealer.tech_count == null || this.dealer.tech_count == 0)
      && (this.sub.maxAllowedUniqueDealerTechnicianLogins == null || this.sub.maxAllowedUniqueDealerTechnicianLogins == 0))) {
      this.dealer.tech_count = 1;
      this.countUpdated = true;
    }
  }

  addSubscription(): void {
    var expires: Date = new Date();
    expires.setFullYear(expires.getFullYear() + 100)
    this.sub.startDate = (new Date(0)).toISOString(); // UNIX start
    this.sub.expiresAt = expires.toISOString(); // 100 years from now
    this.sub.maxAllowedUniqueDealerTechnicianLogins = this.sub.maxAllowedUniqueDealerTechnicianLogins == null ? 0 : this.sub.maxAllowedUniqueDealerTechnicianLogins;

    this.fordService.addSubscription(this.sub).subscribe(response => {
      if (this.fleet) {
        this._router.navigate(['/status-enrolled'], {
          queryParams: { ref: 'fleet' },
        });
      } else {
        this._router.navigateByUrl('/status-enrolled')
      }
    });
  }
}
